import { useCallback } from 'react';
import { useShowNotification } from 'js/components/common/Notifications';

import * as server from './server';
import * as helpers from './helpers';

export const useOnSubmit = ({ translate, refetch }) => {
    const showNotification = useShowNotification({ iconType: 'info' });

    return useCallback(async ({ limit = '0' }) => {
        try {
            await server.setPlayerSingleBetLimits({ amount: limit });
            showNotification({ message: translate('setPlayerLimitSuccess') });
            refetch(Date.now());
        } catch (error) {
            return helpers.parseSetPlayerLimitError(error.response?.data, translate('generic.error'));
        }
    }, [refetch, showNotification, translate]);
};
